define([
    "./monitorModule"
], function (module) {
    "use strict";

    return module.service("monitorService", ["monitorUrlService", "$http", "downloadBinary", function (monitorUrlService, $http, downloadBinary) {
        var self = this;

        self.ENDPOINTS = [
            "beans",
            "conditions",
            "monitor-application/custom-env",
            "health",
            "httptrace",
            "info",
            "liquibase",
            "metrics",
            "monitor-application/mappings"
        ];

        self.findApps = function () {
            return $http.get(monitorUrlService.getUrl("monitor-application/get-instances"))
                .then(getData).then(function (dto) {
                    return dto;
                });
        };

        self.findEndpoint = function (instance, endpoint) {
            return $http.get(monitorUrlService.getUrl(instance, endpoint))
                .then(getData);
        };

        self.findEndpointWithBody = function (instance, endpoint, body) {
            return $http.post(monitorUrlService.getUrl(instance, endpoint), body)
                .then(getData);
        };

        self.request = function (instance, request) {
            return $http({
                url: monitorUrlService.getUrl(instance, request.url),
                method: request.method,
                headers: request.headers,
                data: request.body
            });
        };

        self.findLogFiles = function (instance, folder) {
            return $http.get(monitorUrlService.getUrl(instance, "log", "navigate"), {
                params: {
                    folder: folder
                }
            }).then(getData);
        };

        self.downloadLogFile = function (instance, file) {
            return downloadBinary.get(monitorUrlService.getUrl(instance, "log", "download"), file, {
                file: file
            });
        };

        self.searchLogFiles = function (instance, pattern, options) {
            options = options || {};
            return $http.get(monitorUrlService.getUrl(instance, "log", "search"), {
                params: {
                    pattern: pattern,
                    before: options.before,
                    after: options.after,
                    fileGlob: options.fileGlob
                }
            }).then(getData);
        };

        self.tailLogFile = function (instance, file, startByte, bytesToRead) {
            return $http.get(monitorUrlService.getUrl(instance, "log", "tail"), {
                params: {
                    file: file,
                    startByte: startByte,
                    bytesToRead: bytesToRead
                }
            }).then(getData);
        };

        self.updateEnv = function (instance, propertyName, propertyValue) {
            return $http.post(monitorUrlService.getUrl(instance, "monitor-application/custom-env"), null, {
                params: {
                    propertyName: propertyName,
                    propertyValue: propertyValue
                }
            })
                .then(function () {
                    return $http.post(monitorUrlService.getUrl(instance, "monitor-application/refresh"));
                })
                .then(getData);
        };

        return self;
    }]);

    function getData(response) {
        return response.data;
    }
});